/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getId } from '@fluentui/utilities';
import { EntityStore } from 'src/core/types/EntityStore';
import { ExportedEntitySwagger } from 'src/core/types/EntitySwagger';

export const cluEntitySwaggerToCluEntityStore = (entitySwagger: ExportedEntitySwagger) =>
    new EntityStore({
        name: entitySwagger.category,
        compositionSetting: entitySwagger.compositionSetting,
        requiredComponents: entitySwagger?.requiredComponents,
        prebuilts: entitySwagger?.prebuilts?.map(prebuilt => ({ ...prebuilt, id: getId() })),
        sublists: entitySwagger.list?.sublists?.map(sublist => ({ ...sublist, id: getId() })),
        regexList: entitySwagger.regex?.expressions.map(r => ({
            expression: r.regexPattern,
            id: r.regexKey,
            language: r.language,
            regexKey: r.regexKey
        }))
    });

export const cluEntityStoreToEntitySwagger = (
    store: Pick<EntityStore, 'name' | 'sublists' | 'compositionSetting' | 'prebuilts' | 'requiredComponents' | 'regexList'>
): ExportedEntitySwagger => ({
    category: store.name,
    compositionSetting: store.compositionSetting,
    requiredComponents: store.requiredComponents.length > 0 ? store.requiredComponents : null,
    prebuilts: store.prebuilts.length > 0 ? store.prebuilts.map(p => ({ category: p.category })) : null,
    list: store.sublists.length > 0 ? { sublists: store.sublists.map(s => ({ listKey: s.listKey, synonyms: s.synonyms })) } : null,
    ...(store.regexList.length && {
        regex: { expressions: store.regexList.map(r => ({ regexKey: r.regexKey, language: r.language, regexPattern: r.expression })) }
    })
});
